import { observable, makeObservable } from 'mobx';
import { createModelSchema, list, primitive } from 'serializr';

import { optional } from '@vromo/models';

export type ContactMethod = "sms" | "phone"
export type AvailableContactProtocol = { [K in ContactMethod]: string }
/** used for html elements */
export const ContactProtocol: AvailableContactProtocol = {
    phone: 'tel',
    sms: 'sms',
};

export class Contact {
    address?: string | null = null;
    email: string | null = null;
    name: string | null = null;
    phone: string | null = null;
    imageUrl: string | null = null;
    methods?: ContactMethod[]

    constructor(init?: Partial<Contact>) {
        makeObservable(this, {
            address: observable,
            email: observable,
            name: observable,
            phone: observable,
            imageUrl: observable,
            methods: observable
        });

        Object.assign(this, init);
    }

    /** @note BE wont accept empty string phones */
    setPhone(phoneNumber: string | null): Contact {
        this.phone = phoneNumber && phoneNumber.length > 0 ? phoneNumber : null
        return this
    }

    /** tells whether contact button should be displayed, based on phone country and phone masking enabled
     * @note TODO https://vromo.atlassian.net/browse/VRO-309
     * @note Twillio phone masking depends on which phone the job shows as customer contact, NOT  driver contact
     */
    showMaskedPhone({ type, masking }: { type: ContactMethod, masking?: boolean }): boolean {

        if (!masking)
            return true

        if (!this.phone)
            return false

        if (type === 'sms')
            return (
                // uk
                this.phone.startsWith('+44') ||
                // usa & canada
                this.phone.startsWith('+1') ||
                // australia
                this.phone.startsWith('+61') ||
                // Italy
                this.phone.startsWith('+39') ||
                // Switzerland
                this.phone.startsWith('+41') ||
                // Ireland
                this.phone.startsWith('+353')
            )
        // if (type === 'phone')
        return (
            // uk
            this.phone.startsWith('+44') ||
            // usa & canada
            this.phone.startsWith('+1') ||
            // ireland (only voice)
            this.phone.startsWith('+353') ||
            // australia
            this.phone.startsWith('+61') ||
            // Italy
            this.phone.startsWith('+39') ||
            // New zealand
            this.phone.startsWith('+64') ||
            // Switzerland
            this.phone.startsWith('+41')
        )
    }
}

createModelSchema(Contact, {
    address: optional(primitive()),
    email: optional(primitive()),
    name: optional(primitive()),
    phone: optional(primitive()),
    imageUrl: optional(primitive()),
    methods: optional(list(primitive()))
});
